module.exports = __webpack_public_path__ + "static/media/nav-icon-partnercommunication.05bb4f12.svg";